import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import classnames from 'classnames';
import { Heading } from '@grandvisionhq/elements';

const StoreBrands = (_param)=> {
    var { className , labels , brands  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "labels",
        "brands"
    ]);
    return React__default.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('store-brands-stores-v2', className)
    }), /*#__PURE__*/ React__default.createElement(Heading, {
        variant: "smallest",
        component: "h3"
    }, labels.title), /*#__PURE__*/ React__default.createElement("ul", {
        className: "store-brands-stores-v2__list"
    }, brands.map(({ name  })=>/*#__PURE__*/ React__default.createElement("li", {
            key: name,
            className: "store-brands-stores-v2__list-item"
        }, name)
    )));
};
var StoreBrands$1 = StoreBrands;

export { StoreBrands$1 as default };
//# sourceMappingURL=StoreBrands.js.map
